import { TFunction } from 'i18next';
import { FieldOfficeCountOtp } from 'src/graphql/generated/graphql';
import { CountOtpColumn } from './columns';
import { DataTableMeta } from '@otp/ui';

export const getTableConfig = (
  data: FieldOfficeCountOtp[],
  { t }: { t: TFunction },
) => [
  {
    name: 'name',
    label: t('columns.name'),
  },
  {
    name: 'countryCode',
    label: t('columns.country-code'),
  },
  {
    name: 'otp1Count',
    label: t('columns.otp1'),
    options: {
      customBodyRender: (_: any, column: DataTableMeta) => {
        const fieldOfficeCountOtp = data[column.rowIndex];

        return (
          <CountOtpColumn column="otp1Count" entity={fieldOfficeCountOtp} />
        );
      },
    },
  },
  {
    name: 'otp2Count',
    label: t('columns.otp2'),
    options: {
      customBodyRender: (_: any, column: DataTableMeta) => {
        const fieldOfficeCountOtp = data[column.rowIndex];

        return (
          <CountOtpColumn column="otp2Count" entity={fieldOfficeCountOtp} />
        );
      },
    },
  },
  {
    name: 'otp3Count',
    label: t('columns.otp3'),
    options: {
      customBodyRender: (_: any, column: DataTableMeta) => {
        const fieldOfficeCountOtp = data[column.rowIndex];

        return (
          <CountOtpColumn column="otp3Count" entity={fieldOfficeCountOtp} />
        );
      },
    },
  },
  {
    name: 'otp4Count',
    label: t('columns.otp4'),
    options: {
      customBodyRender: (_: any, column: DataTableMeta) => {
        const fieldOfficeCountOtp = data[column.rowIndex];

        return (
          <CountOtpColumn column="otp4Count" entity={fieldOfficeCountOtp} />
        );
      },
    },
  },
];
